import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import AttributeMgmtBoard from './components/AttributeMgmtBoard';

const AttributeMgmtPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Attribute Setting</h3>
      </Col>
    </Row>
    <Row>
      <AttributeMgmtBoard />
    </Row>
  </Container>
);

export default AttributeMgmtPage;
